import Account from '@/lib/account'
import i18n from '@/lib/i18n'
import { RefLineTypes } from '@/lib/constants'
import UserInfo from '@/lib/user-info'
import router from '@/router'
import * as SystemOfUnits from '@/lib/system-of-units'
import FieldNameMixin from '@/components/mixins/field-name-mixin'

export default {
  mixins: [FieldNameMixin],
  methods: {
    checkAvailabilityBeforeMount() {
      if (UserInfo.hasFreeFunctionality()) {
        const message = i18n.tt('StandardPlanIsNeededDialogMessage')
        alert(message)
        router.push({ name: 'BillingBilling' })
      }
    },
    getRefLineName(refLine) {
      if (!refLine.name) {
        return i18n.tt('customNameNotRegistered')
      }
      return refLine.name
    },

    getGuidanceIntervalAsString(refLine) {
      const value = Math.abs(refLine.guidanceInterval)
      return SystemOfUnits.getLengthTextFrom(value, { format: SystemOfUnits.FORMAT_TRIPLE_ZERO })
    },
    getLineLengthAsString(refLine) {
      const value = Math.abs(refLine.length)
      return SystemOfUnits.getLengthTextFrom(value, { format: SystemOfUnits.FORMAT_SINGLE_ZERO })
    },

    getDirectionAsString(refLine) {
      return Math.round(refLine.refDirection * 1000) / 1000 + '°'
    },
    getTypeAsString(refLine) {
      const type = refLine.refLineType
      if (RefLineTypes.Straight === type) {
        return i18n.tt('DefaultRefLineTypeStraight')
      } else if (RefLineTypes.Curved === type) {
        return i18n.tt('DefaultRefLineTypeCurved')
      }
      return '???'
    },
    getAccount(refLine) {
      return Account.getByRefLine(refLine)
    },
    isMyRefLine(refLine) {
      return this.$store.getters.loginUsername === refLine.username
    },
    getFieldNameFromFieldGeoInfoKeyFromRefLine(refline) {
      if (UserInfo.isFSMigrated()) {
        if (!refline.fieldName) {
          return i18n.tt('customFieldNoName')
        }
        return refline.fieldName
      } else {
        return this.getFieldNameFromFieldGeoInfoKey(refline.fieldItemKey)
      }
    },
  },
}
